<span *ngIf="short" class="clickable small" (click)="showfull()"
  >{{ shorttext }} <span class="font-weight-bold">{{ extra }}</span></span
>
<span *ngIf="!short" class="clickable small" (click)="showshort()">{{
  fulltext
}}</span>
